import request from "@/api/config_tgbot.js";

export function sendNotificationForUser(data) {
  return request({
    url: `notifications`,
    method: "post",
    data,
  });
}
